import Phaser from 'phaser';
import { VIEWPORT_H, VIEWPORT_W } from './constants';
import { syncHudViewport } from './viewport-fit';

/** Visible panel aspect — one half of the Booga Town background. */
export const GAME_ASPECT = VIEWPORT_W / VIEWPORT_H;

/** Device is wider than the game panel (tablets, unfolded foldables, etc.). */
export function isDeviceTooWide(
  width = window.innerWidth,
  height = window.innerHeight,
) {
  if (height <= 0) return false;
  return width / height > GAME_ASPECT;
}

export function scaleModeForDevice(
  width = window.innerWidth,
  height = window.innerHeight,
): typeof Phaser.Scale.FIT | typeof Phaser.Scale.ENVELOP {
  return isDeviceTooWide(width, height) ? Phaser.Scale.FIT : Phaser.Scale.ENVELOP;
}

export function bindAdaptiveViewbox(game: Phaser.Game, shell: HTMLElement) {
  const apply = () => {
    const tooWide = isDeviceTooWide();
    const nextMode = scaleModeForDevice();

    if (game.scale.scaleMode !== nextMode) {
      game.scale.scaleMode = nextMode;
    }
    game.scale.refresh();
    shell.classList.toggle('viewbox-active', tooWide);
    document.body.classList.toggle('viewbox-active', tooWide);
    syncHudViewport(game);
  };

  apply();
  window.addEventListener('resize', apply);
  window.visualViewport?.addEventListener('resize', apply);
  game.scale.on('orientationchange', apply);

  return () => {
    window.removeEventListener('resize', apply);
    window.visualViewport?.removeEventListener('resize', apply);
  };
}
